import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 21 23"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#2B335B",
      d: "M14 2.11a.937.937 0 0 0-.624 1.767 8.625 8.625 0 1 1-5.751 0A.937.937 0 0 0 7 2.11a10.5 10.5 0 1 0 6.998 0Z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#2B335B",
      d: "M10.5 10.715a.938.938 0 0 0 .938-.937V.938a.938.938 0 0 0-1.876 0v8.84a.938.938 0 0 0 .938.937Z"
    }, null, -1)
  ]))]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "logout-fatec"}) } }